// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 566) return "static/chunks/566-474bca8d511927a9.js";
	if (chunkId === 201) return "static/chunks/201-16266d628a82cbcc.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"97fdc08aded7edf7","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"9f36f8d41ec71f0f","367":"f588f655627d2162","639":"9463c4fce44c5b3d","748":"d6bbdc0d158ca65a"}[chunkId] + ".js";
};